import { ListFilter } from "@components/data-table/filters/listFilter";
import { FilterFormProps } from "@components/data-table/filters/popoverDialog";

export const ManufacturerListFilter = (props: FilterFormProps) => <ListFilter filterField={'manufacturers'} showNot {...props} />;
export const ModelListFilter = (props: FilterFormProps) => <ListFilter filterField={'models'} showNot {...props} />;
export const GroupListFilter = (props: FilterFormProps) => <ListFilter filterField={'groups'} showNot {...props} />;
export const HomeLocationsListFilter = (props: FilterFormProps) => <ListFilter filterField={'homeLocations'} showNot {...props} />;
